import { applyMiddleware, compose } from "redux";
import { legacy_createStore as createStore } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers/";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

/**
 * Setup redux store for Checkout
 *
 * @export
 * @param {*} [initialState={}]
 * @return {*}
 */
export default function configureStore(initialState = {}) {
  return createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(thunk)));
}

export const store = configureStore();
